import React from 'react';

const TestimonialCard = ({ text, authorName, authorRole, authorInitial }) => {
  return (
    <div className="testimonial-card">
      <div className="quote-icon">"</div>
      <p className="testimonial-text">{text}</p>
      <div className="testimonial-author">
        <div className="author-avatar">{authorInitial}</div>
        <div className="author-info">
          <h4>{authorName}</h4>
          <span>{authorRole}</span>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
